import { Component, OnInit, ViewChild } from "@angular/core";
import { IonContent } from "@ionic/angular";
import { Navigator } from "src/app/components/menu/navigator";
import { PiggyBankService } from "src/app/services/piggybank/piggybank.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import {TransformOffersService} from "src/app/services/transform-offers/transform-offers.service"
import { Platform } from "@ionic/angular";

@Component({
  selector: "app-piggy-bank",
  templateUrl: "./piggy-bank.component.html",
  styleUrls: ["./piggy-bank.component.scss"],
})
export class PiggyBankComponent implements OnInit {
  isBoydMember: boolean;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  skippedFrom: string;
  purchaseRates;
  currentBalance: number;
  priceAmount: any = 0;
  itemInfo: any;
  isAuthenticated: boolean;
  priceCode: any ="coins_1.99usd";
  credits: any;
  points: any;
  status: string;
  piggyImage: string;
  isBiggerAmount: boolean;
  isBoydAmount: boolean = false;
  constructor(
    public navigator: Navigator,
    private piggyBankService: PiggyBankService,
    private userSessionService: UserSessionService,
    private platform: Platform,
    private transformService:TransformOffersService,
    private utils:UtilsService
  ) {}

  ngOnInit(): void {
    this.checkAuthentication();
  }

  ionViewWillEnter(){
     // Get Piggy Bank Information
    this.piggyBankService.getPiggyBankInfo().subscribe((res) => {
	
      if (res.payload) {
      
        this.priceAmount = res.payload.piggyBankDef.purchaseRates[0].priceAmount;
        this.priceCode = res.payload.piggyBankDef.purchaseRates[0].priceCode;
        this.currentBalance = res.payload.currentBalance;
        this.credits =  res.payload.piggyBankDef.purchaseRates[0].tierCredits;
        this.points = res.payload.piggyBankDef.purchaseRates[0].boydPoints;
        this.status = res.payload.status;

        this.piggyBankService.setPiggyStatus(this.status);

        if(this.points){
          this.isBoydAmount = true;
        }

        const numberString = this.currentBalance.toString();
        let decimalIndex = numberString.indexOf('.');
        if(decimalIndex < 0){
          decimalIndex = numberString.toString().length;
        }
        if(decimalIndex > 6)
        {
          this.isBiggerAmount = true;
        }else {
          this.isBiggerAmount = false;
        }


        this.getPiggyImage();
        this.itemInfo = {
          priceCode: this.priceCode,
          price: this.priceAmount,
          priceAmount:this.priceAmount,
          chips: this.currentBalance,
          isAuthenticated: this.isAuthenticated,
          credits: this.credits,
          points: this.points,
          is_Piggy_Bank: true,
        };
        if(this.platform.is('capacitor')){
         try{
          this.itemInfo = this.transformService.transformOfferPrices([this.itemInfo])[0];
          this.priceAmount = this.itemInfo.priceAmount
         }catch(e){
         console.log("Error",e)
        }
       }
      }else {
        this.piggyImage = "imgs/BreakPigScreen1.png";
      }
    });
  }

  getPiggyImage(){
    if(this.status === "FULL"){
      this.piggyImage = "imgs/PiggyBank_win_Full.png"; 
    }else {
      this.piggyImage  = "imgs/BreakPigScreen1.png";
    }  
  }
  checkAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      if (isAuthenticated) {
        this.isAuthenticated = true;
      }
    });
    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.isAuthenticated = true;
      }
    });
  }
}
